import {
    Container,
    Content,
    Description,
    Title,
    ButtonContainer,
    LinkButton
} from './UnsupportedScreenSize.styles';
import { Header } from './Header';
import { useContext } from 'react';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
import { getConfig } from '../config/envconfig';

type TranslationKeys =
    | 'ahuDesign.unsupportedScreenSize.hi'
    | 'ahuDesign.unsupportedScreenSize'
    | 'ahuDesign.useLargerScreenSize'
    | 'ahuDesign.unsupportedScreenSize.buttonText';

const FallbackTexts = (key: TranslationKeys): string => {
    const texts: { [key in TranslationKeys]: string } = {
        'ahuDesign.unsupportedScreenSize.hi': 'Hi',
        'ahuDesign.unsupportedScreenSize':
            'Currently we are not supporting your device, but we are working on it.',
        'ahuDesign.useLargerScreenSize':
            'In the meantime, you are welcome to use AHU Design Light from a device with a larger screen.',
        'ahuDesign.unsupportedScreenSize.buttonText': 'Back to swegon.com'
    };
    return texts[key] ?? 'Unmapped error message';
};

const UnsupportedScreenSize = () => {
    const {
        l,
        loading: translationsLoading,
        error: translationError
    } = useContext(TranslationContext);
    const config = getConfig();

    const translations = (key: TranslationKeys) => {
        if (!translationsLoading && translationError) {
            return FallbackTexts(key);
        } else {
            return l(key);
        }
    };

    return (
        <>
            <Header />
            <Container>
                <Content>
                    <Title>{`${translations('ahuDesign.unsupportedScreenSize.hi')},`}</Title>
                    <Description>
                        <p>{translations('ahuDesign.unsupportedScreenSize')}</p>
                        &nbsp;
                        <p>{translations('ahuDesign.useLargerScreenSize')}</p>
                    </Description>
                    <ButtonContainer>
                        <LinkButton
                            href={
                                config?.web_product_info ||
                                'https://www.swegon.com/'
                            }
                            referrerPolicy="no-referrer"
                            target="_blank"
                        >
                            {translations(
                                'ahuDesign.unsupportedScreenSize.buttonText'
                            ).toLocaleUpperCase()}
                        </LinkButton>
                    </ButtonContainer>
                </Content>
            </Container>
        </>
    );
};

export default UnsupportedScreenSize;
